/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'
import {useMutation, useQueryClient} from 'react-query'
import {MenuComponent} from '../../../../../../../_metronic/assets/ts/components'
import {ID, KTIcon, QUERIES} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../core/UsersListViewProvider'
import {useQueryResponse} from '../../core/QueryResponseUsersProvider'
import {deleteMedium} from '../../core/_requests'
import { useNavigate } from 'react-router-dom'

type Props = {
  id: ID
}

const TemplosActionsCell: FC<Props> = ({id}) => {
  const {setItemIdForUpdate} = useListView()
  const navigate = useNavigate()
  const {refetch} = useQueryResponse()

  const {query} = useQueryResponse()
  const queryClient = useQueryClient()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const detalhe = (withRefresh?: boolean) => {
    setItemIdForUpdate(id)
    if (withRefresh) {
      refetch()
    }
    let view_path = `/app/enroll/templo/${id}/detalhe`; 
    navigate(view_path);
  }

  return (
    <>
      <a
        href='#'
        className='btn btn-light btn-active-light-primary btn-sm'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        Ações
        <KTIcon iconName='down' className='fs-5 m-0' />
      </a>
      {/* begin::Menu */}
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4'
        data-kt-menu='true'
      >
        {/* begin::Menu item */}
        <div className='menu-item px-5'>
          <a className='menu-link px-5' onClick={() => detalhe()}>
            Visualizar
          </a>
        </div>
        {/* end::Menu item */}

        {/* begin::Menu item */}
       {/*  <div className='menu-item px-3'>
          <a
            className='menu-link px-3'
            data-kt-users-table-filter='delete_row'
            onClick={async () => await deleteItem.mutateAsync()}
          >
            Delete
          </a>
        </div>*/}
        {/* end::Menu item */}
      </div>
      {/* end::Menu */}
    </>
  )
}

export {TemplosActionsCell}
